import Expandable from "../utils/classes/Expandable";

export default function(el, animationDuration) {
    const expandableEls = el.querySelectorAll(".expandable");
    const expandables = [];

    const handleOpenEvent = (expandable) =>
        expandables.forEach((e) => expandable !== e && e.isOpened && e.toggleExpandable(false));

    if (!expandableEls.length) return;

    for (const expandableEl of expandableEls) {
        const expandable = new Expandable(expandableEl, animationDuration);
        expandable.on("open", handleOpenEvent.bind(null, expandable));
        expandable.init();
        expandables.push(expandable);
    }
}
